import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=8e7f45b8&scoped=true"
import script from "./ModuleHeader.vue?vue&type=script&lang=js"
export * from "./ModuleHeader.vue?vue&type=script&lang=js"
import style0 from "./ModuleHeader.vue?vue&type=style&index=0&id=8e7f45b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_css-loader@6.11.0_webpack@5.105.4__lodash@4_35a4cbb8ce890fb5ff46e42cee80c8ce/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7f45b8",
  null
  
)

export default component.exports